export enum MediaSuggestionType {
  Category = "CATEGORY",
  Person = "PERSON",
  Phrase = "PHRASE",
}
